// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgDataTransferUp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 4v1m0 4v1m10 10V4m0 0 3 3m-3-3-3 3m-7 7v6m0 0 3-3m-3 3-3-3"
    />
  </svg>
);
export const DataTransferUpIcon = forwardRef(SvgDataTransferUp);
